/**
 * Adds a change event handler for each of two radio element options that will determine if the element target will
 * be shown or hidden.
 *
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element", "hideControl", "showControl"];

  connect() {
    this.updateTargetVisibility();
  }

  showControlTargetConnected(element) {
    element.addEventListener("change", this.updateTargetVisibility.bind(this));
  }

  hideControlTargetConnected(element) {
    element.addEventListener("change", this.updateTargetVisibility.bind(this));
  }

  updateTargetVisibility() {
    const shouldShow = this.hasShowControlTarget && this.showControlTarget.checked;

    this.elementTargets.forEach((element) => {
      element.classList.toggle("d-none", !shouldShow);
    });
  }
}
